import React from "react";
import "./SelectableRoles.css";

function RolePill(props: { role: never, selected: boolean, onClick: never }) {
    return <div className={"pill role" + (props.selected ? " selected" : "")} onClick={() => {
        props.onClick(props.role)
    }}>
        {props.role.name}
    </div>
}

function SelectableRoles(props: {
    roles: never[],
    selectedRoles: never[],
    setSelectedRoles: (value: (((prevState: never[]) => never[]) | never[])) => void,
    showLabel?: boolean
}) {
    function isSelected(role) {
        for (const selectedRole of props.selectedRoles) {
            if (selectedRole.id === role.id) {
                return true
            }
        }
        return false
    }
    function removeRole(role) {
        const newRoles = []
        for (const selectedRole of props.selectedRoles) {
            if (selectedRole.id !== role.id) {
                newRoles.push(selectedRole)
            }
        }
        props.setSelectedRoles(newRoles)
    }
    function addRole(role) {
        props.setSelectedRoles([...props.selectedRoles, role])
    }

    const rolePills = props.roles.map((role) => {
        const selected = isSelected(role)
        return <RolePill key={role.id} role={role} selected={selected} onClick={(role) => {
            if (selected) {
                removeRole(role)
            } else {
                addRole(role)
            }
        }}/>
    })

    let label = null
    if (props.showLabel) {
        label = <div className="selectable-roles-label">Roles</div>
    }
    return <div className="selected-roles-wrapper">
        {label}
        <div className="selectable-roles">
            {rolePills}
        </div>
    </div>
}

function SelectedRoles({selectedRoles, showLabel=true}: { selectedRoles: never[], showLabel: boolean }) {
    let label = null
    if (showLabel) {
        label = <div className="selected-roles-label">Selected Roles:</div>
    }
    return <div className="selected-roles">
        {label}
        {selectedRoles.map((role) => {
            return <RolePill key={role.id} role={role} selected={true} onClick={null}/>
        })}
    </div>
}

export default SelectableRoles;
export {RolePill, SelectedRoles};